/**
 * MSAL, restricted to the FCC tenant.
 *
 * Tenant-scoped authority (not /common) is what keeps this FCC-only: a personal or
 * guest account cannot complete sign-in against a single-tenant authority.
 */
import type { Configuration, PopupRequest } from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'

const tenantId = import.meta.env.VITE_AAD_TENANT_ID as string | undefined
const clientId = import.meta.env.VITE_AAD_CLIENT_ID as string | undefined

export const isConfigured = Boolean(tenantId && clientId)

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? '',
    authority: `https://login.microsoftonline.com/${tenantId ?? 'organizations'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage: one sign-in for every tab of this app, so a new tab opens without a trip to
    // Microsoft (Yehuda, 2026-10-13). Sign-out clears it for all tabs. The same setting in
    // cost-per-claim, fcc-portal and labor-hours: keep them in step.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) console.warn('[msal]', message)
      },
    },
  },
}

/** Scope requested for the dataset API. Falls back to the default OIDC scopes. */
export const loginRequest: PopupRequest = {
  scopes: import.meta.env.VITE_API_SCOPE
    ? [import.meta.env.VITE_API_SCOPE as string]
    : ['openid', 'profile', 'email'],
}
